// extracted by mini-css-extract-plugin
export default {"labelRoot":"CustomSelect_labelRoot__xGadA","select":"CustomSelect_select__jVhWY","item":"CustomSelect_item__yXtaO","errorHelper":"CustomSelect_errorHelper__HP48c"};